import { getDataIdsFromContract } from '../../../../shared/utils/dataId';

export const jobObjectStagesDataId = getDataIdsFromContract({
  base: 'job-object-stages',
  container: 'container'
});
